<template>
    <div class="todo-popper">
        <div class="todo-popper_header">
            <div
                :class="['type-item flex-center', { active: type === item.value }]"
                v-for="item in typeList"
                :key="item.value"
                @click="handleTabChange(item)"
            >
                {{ item.label }}
            </div>
        </div>

        <div class="todo-popper_box">
            <template v-if="todoList.length > 0">
                <div class="todo-item" v-for="item in todoList" :key="item.id" @click="handleToDetail(item)">
                    <div :class="['item-mode', `mode-${item.task_info?.task_mode}`]">
                        {{ item.task_info?.task_mode === 1 ? "招募" : "竞单" }}
                    </div>

                    <div class="item-info">
                        <div class="info-title ellipsis-single">{{ item.task_info?.task_name }}</div>
                        <div class="info-operate">{{ item.todo_key_name }}</div>
                    </div>
                </div>
            </template>

            <div class="box-empty flex-center" v-else>暂无数据</div>
        </div>

        <div class="todo-popper_footer flex-center">
            <div class="btn" @click="handleToAll">查看全部</div>
        </div>
    </div>
</template>

<script>
import taskApi from "../../apis/task";

export default {
    data() {
        return {
            type: 1,
            typeList: [
                { label: "企业需求", value: 2 },
                { label: "教师需求", value: 1 },
            ],
            todoList: [],
            pageParams: {
                page: 1,
                page_size: 5,
            },
        };
    },

    created() {
        this.getTodoList();
    },

    methods: {
        // 获取待办列表数据
        getTodoList() {
            const params = {
                filter_todos: 1,
                user_type: this.type,
                ...this.pageParams,
            };

            this.$httpStudent.axiosGetBy(taskApi.studentTodo, params, (res) => {
                if (res.code === 200) {
                    this.todoList = res.data?.data ?? [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 查看全部
        handleToAll() {
            this.$router.push({ path: "/student/newTask/list" });
            this.$emit("hide-popper");
        },

        // 查看详情
        handleToDetail(todo) {
            if (todo.todo_key === 11) {
                this.$message.warning("需求已被下架，无法查看");
                return;
            }

            const url = this.$router.resolve({
                path: "/student/newTask/detail",
                query: { id: todo.task_id },
            }).href;

            window.open(url, "_blank");
            this.$emit("hide-popper");
        },

        handleTabChange(tab) {
            this.type = tab.value;

            this.getTodoList();
        },
    },
};
</script>

<style lang="scss" scoped>
.todo-popper {
    &_header {
        height: 40px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;

        .type-item {
            height: 100%;
            padding-inline: 16px;
            cursor: pointer;
            box-sizing: border-box;

            &.active {
                color: #685ef5;
                border-bottom: 2px solid #685ef5;
            }
        }
    }

    &_box {
        padding-inline: 24px 16px;

        .todo-item {
            margin-top: 16px;
            display: flex;
            gap: 10px;
            cursor: pointer;

            & + .todo-item {
                margin-top: 24px;
            }

            .item-mode {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                font-weight: 600;
                font-size: 12px;
                line-height: 32px;
                text-align: center;

                &.mode-1 {
                    background: #f6ffed;
                    border: 1px solid #01a04b;
                    color: #6bc45c;
                }

                &.mode-2 {
                    background: #fff4dd;
                    border: 1px solid #e49906;
                    color: #e49906;
                }
            }

            .item-info {
                flex: 1;
                min-width: 0;

                .info-title {
                    font-weight: 500;
                    font-size: 14px;
                    color: #4e4d5c;
                }

                .info-operate {
                    font-weight: 400;
                    font-size: 12px;
                    color: #767779;
                }
            }
        }

        .box-empty {
            height: 300px;
            color: #a5a5a5;
        }
    }

    &_footer {
        margin-top: 16px;
        height: 40px;
        margin-inline: 16px;
        border-top: 1px solid #e7e7e7;
        justify-content: flex-end;

        .btn {
            font-weight: 400;
            font-size: 12px;
            color: #a5a5a7;
            cursor: pointer;
        }
    }
}
</style>
